import { NAVIGATION_BREAKPOINT } from '../../utils/constants'

const MobileMenu = (function () {
  // Query menu elements
  let toggleBtns = document.querySelectorAll('.js-menu-toggle-btn')
  let openBtn = document.querySelector('.js-menu-toggle-btn--open')
  let closeBtn = document.querySelector('.js-menu-toggle-btn--close')
  let mobileMenuPanel = document.querySelector('.js-mobile-menu-panel')

  // Vars for monitoring responsive state to init/destory menu appropriately
  let curNavMode // 'mobile' or 'desktop'
  let mediaQuery = window.matchMedia(`(min-width: ${NAVIGATION_BREAKPOINT})`)

  const initViewportSizeListener = () => {
    /**
     * Safari <14 doesn't support addEventListener so have added fallback.
     * See: https://stackoverflow.com/questions/62693995/addeventlistener-is-not-a-function-for-matchmedia-in-safari-browser
     */
    if (mediaQuery?.addEventListener) {
      mediaQuery.addEventListener('change', handleViewportChange)
    } else {
      mediaQuery.addListener(handleViewportChange)
    }
  }

  const handleViewportChange = () => {
    let newMode = mediaQuery.matches ? 'desktop' : 'mobile'

    if (newMode !== curNavMode) {
      if (newMode === 'mobile') {
        initMobileMenu()
        curNavMode = 'mobile'
      } else if (!!curNavMode) {
        destroyMobileMenu()
        curNavMode = 'desktop'
      }
    }
  }

  const initMobileMenu = () => {
    if (openBtn) {
      openBtn.addEventListener('click', openMenu)
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu)
    }
    /**
     * If menu recieves focus via keyboard navigation, make sure
     * menu is shown/hidden appropriately.
     */
    if (mobileMenuPanel) {
      mobileMenuPanel.addEventListener('focusin', openMenu)
      mobileMenuPanel.addEventListener('focusout', handleFocusOut)
    }
  }

  const destroyMobileMenu = () => {
    contractMenuPanel()
    toggleAriaExpanded(false)
    unlockOverflowOnBody()
    removeEventListeners()
  }

  const removeEventListeners = () => {
    if (openBtn) {
      openBtn.removeEventListener('click', openMenu)
    }
    if (closeBtn) {
      closeBtn.removeEventListener('click', closeMenu)
    }
    if (mobileMenuPanel) {
      mobileMenuPanel.removeEventListener('focusin', openMenu)
      mobileMenuPanel.removeEventListener('focusout', handleFocusOut)
    }
  }

  const handleFocusOut = (e) => {
    if (mobileMenuPanel) {
      const isFocusOutsideMenuPanel = !mobileMenuPanel.contains(e.relatedTarget)
      if (isFocusOutsideMenuPanel) {
        closeMenu()
      }
    }
  }

  const openMenu = () => {
    if (mobileMenuPanel) {
      if (!isMenuOpen(mobileMenuPanel)) {
        expandMenuPanel()
        moveFocusToCloseMenuBtn()
        toggleAriaExpanded(true)
        lockOverflowOnBody()
      }
    }
  }

  const closeMenu = () => {
    if (mobileMenuPanel) {
      contractMenuPanel()
      toggleAriaExpanded(false)
      unlockOverflowOnBody()
    }
  }

  const expandMenuPanel = () => {
    if (mobileMenuPanel) {
      mobileMenuPanel.classList.add('c-header__menu-container--expanded')
    }
  }

  const contractMenuPanel = () => {
    if (mobileMenuPanel) {
      mobileMenuPanel.classList.remove('c-header__menu-container--expanded')
    }
  }

  const toggleAriaExpanded = (isMenuOpen) => {
    toggleBtns.forEach((btn) => {
      btn.ariaExpanded = isMenuOpen
    })
  }

  const moveFocusToCloseMenuBtn = () => {
    if (closeBtn) {
      closeBtn.focus()
    }
  }

  const lockOverflowOnBody = () => {
    document.body.classList.add('_lock-overflow')
  }

  const unlockOverflowOnBody = () => {
    document.body.classList.remove('_lock-overflow')
  }

  const isMenuOpen = () => {
    return mobileMenuPanel.classList.contains('c-header__menu-container--expanded')
  }

  return {
    init: () => {
      initViewportSizeListener()
      handleViewportChange()
    },
  }
})()

export default MobileMenu
